import React, { Component } from 'react';

import keyCodes from '@components/GlobalSearch/Utils/keyCodes';

function withKeyboardControl(WrappedComponent) {
    return class KeyboardControl extends Component {
        constructor(props) {
            super(props);
            this.state = {};
            this.handleKeyPress = this.handleKeyPress.bind(this);
        }

        handleKeyPress(e) {
            e.preventDefault();
            e.stopPropagation();
            const { UP, DOWN, TAB } = keyCodes;
            const { onUpKey, onDownKey, onShiftTabKey, onTabKey } = this.props;

            switch (e.keyCode) {
                case UP:
                    onUpKey(e);
                    break;
                case e.shiftKey && TAB:
                    onShiftTabKey(e);
                    break;
                case DOWN:
                    onDownKey(e);
                    break;
                case TAB:
                    onTabKey(e);
                    break;
            }
        }

        render() {
            return <WrappedComponent onKeyDown={this.handleKeyPress} {...this.props} />;
        }
    };
}

export default withKeyboardControl;
